package dev.moetz.sslcertificatetool.page

import dev.moetz.materialize.mButton
import dev.moetz.materialize.mCol
import dev.moetz.materialize.mContainer
import dev.moetz.materialize.mHeader
import dev.moetz.materialize.mRow
import dev.moetz.materialize.showErrorToast
import dev.moetz.sslcertificatetool.design.mFooter
import dev.moetz.sslcertificatetool.http.SubmitDomainRequestBody
import dev.moetz.sslcertificatetool.http.SubmitDomainResponseBody
import dev.moetz.sslcertificatetool.util.ClientServiceManager
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.label
import web.cssom.ClassName
import web.dom.ElementId
import web.html.InputType
import web.html.url
import kotlin.uuid.ExperimentalUuidApi

external interface ChannelPageServiceProps : Props {
    var manager: ChannelPageServiceManager
}

@OptIn(ExperimentalUuidApi::class)
class ChannelPageServiceManager : ClientServiceManager() {

    fun onSubmitDomain(domain: String) {
        scope.launch {
            val response = httpClient.post("/api/rest/domain") {
                contentType(ContentType.Application.Json)
                setBody(SubmitDomainRequestBody(domain, port = 443))
            }

            if (response.status.isSuccess()) {
                val responseBody = response.body<SubmitDomainResponseBody>()
                window.location.href = "/domain/${responseBody.id}"
            } else {
                showErrorToast("Error: ${response.bodyAsText()}")
            }
        }
    }

}

val ChannelPageService = FC<ChannelPageServiceProps> { props ->
    mHeader(title = "SSL Certificate Tool")

    mContainer {
        mRow {
            mCol(small = 12) {
                h3 { +"Enter a domain to check / gather information about its SSL certificate:" }
            }
        }
        mRow {
            mCol(small = 12, medium = 10, large = 10) {
                div {
                    className = ClassName("input-field")
                    ReactHTML.input {
                        id = ElementId("domain-input")
                        type = InputType.url
                        className = ClassName("active white-text")

                        onKeyDown = {
                            if (it.key == "Enter") {
                                props.manager.onSubmitDomain(
                                    domain = document.getElementById("domain-input").asDynamic().value as String
                                )
                            }
                        }
                    }
                    label {
                        className = ClassName("active")
                        htmlFor = ElementId("domain-input")
                        +"URL of the domain to check"
                    }
                }
            }
            mCol(small = 12, medium = 2, large = 2, additionalClass = "right-align") {
                mButton(
                    text = "Submit",
                    color = "green",
                    onClick = {
                        props.manager.onSubmitDomain(
                            domain = document.getElementById("domain-input").asDynamic().value as String
                        )
                    }
                )
            }
        }

    }

    mFooter()
}